import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { useMeilisearch } from 'src/hooks/meilisearch/use-meilisearch';
import { useUserStore } from 'src/store/user-store';
import { fetchEmployeesGroups } from '../lib/employees-groups';
import { employeesGroupsKeys } from '../query-keys/employees-groups';

export const useEmployeesGroupsByTokens = (tokens: string[]) => {
  const { directoryToken } = useUserStore();

  const searchState: SearchState = {
    filter: [tokens.map(token => `token = ${token}`) ?? []],
    q: '',
    sort: [],
  };

  const query = useMeilisearch({
    fetch: fetchEmployeesGroups,
    queryKey: employeesGroupsKeys.list(
      directoryToken!,
      tokens.length ?? 0,
      0,
      searchState,
    ),
    page: 1,
    perPage: tokens.length ?? 0,
    searchState,
    enabled: tokens.length > 0,
  });

  return query;
};
